const { getElement } = window.BAO.Utils

class ProductSwatches extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.els.swatch?.elements.forEach((swatch) => {
      const parentCard = swatch.closest(this.externalEls.card?.selector)
      const externalImage = getElement(
        `${this.externalEls.image.selector} img`,
        { context: parentCard },
      )

      swatch.addEventListener('mouseover', () => {
        this.fallbackImageSrc = externalImage.src
        this.fallbackImageSrcSet = externalImage.srcset

        externalImage.src = swatch.dataset.image
        externalImage.srcset = ''
      })

      swatch.addEventListener('mouseout', () => {
        externalImage.src = this.fallbackImageSrc
        externalImage.srcset = this.fallbackImageSrcSet
      })
    })
  }
}

if (!customElements.get('product-swatches')) {
  customElements.define('product-swatches', ProductSwatches)
}
